/* tslint:disable */
var TrackingEventFeedback = /** @class */ (function () {
    function TrackingEventFeedback(args) {
        this.EVENT_ID = 123;
        this.MAPPING_VERSION = 2;
        this.data = args;
        this.data.eventId = this.EVENT_ID;
        this.data.event_mapping_version = this.MAPPING_VERSION;
    }
    return TrackingEventFeedback;
}());
export { TrackingEventFeedback };
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/TrackingEventFeedback.ts
// module id = 1696
// module chunks = 3